export default "__VITE_ASSET__DS6EbSJc__"